export default __webpack_public_path__ + "static/grega-cv-0ebce1b55c289589c2d4c852d9841ffc.png";